var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechMarksTopLeftGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76906 4.719C2.82131 3.57825 4.41356 3 6.50081 3H7.25081V5.11425L6.64781 5.235C5.62031 5.4405 4.90556 5.84475 4.52306 6.438C4.32348 6.7576 4.21029 7.12353 4.19456 7.5H6.50081C6.69972 7.5 6.89049 7.57902 7.03114 7.71967C7.17179 7.86032 7.25081 8.05109 7.25081 8.25V13.5C7.25081 14.3273 6.57806 15 5.75081 15H1.25081C1.0519 15 0.861132 14.921 0.72048 14.7803C0.579827 14.6397 0.50081 14.4489 0.50081 14.25V10.5L0.50306 8.31075C0.49631 8.2275 0.35381 6.255 1.76906 4.719ZM14.0008 15H9.50081C9.3019 15 9.11113 14.921 8.97048 14.7803C8.82983 14.6397 8.75081 14.4489 8.75081 14.25V10.5L8.75306 8.31075C8.74631 8.2275 8.60381 6.255 10.0191 4.719C11.0713 3.57825 12.6636 3 14.7508 3H15.5008V5.11425L14.8978 5.235C13.8703 5.4405 13.1556 5.84475 12.7731 6.438C12.5735 6.7576 12.4603 7.12353 12.4446 7.5H14.7508C14.9497 7.5 15.1405 7.57902 15.2811 7.71967C15.4218 7.86032 15.5008 8.05109 15.5008 8.25V13.5C15.5008 14.3273 14.8281 15 14.0008 15Z",
    fill: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechMarksTopLeftGold);
export default __webpack_public_path__ + "static/media/speech-marks-top-left-gold.dab71c4abe0a53a860a69c787a9c8f2a.svg";
export { ForwardRef as ReactComponent };